<template>
  <div>
    <el-row class="store-row">
      <el-col :offset="1">
        <h3>特約店家</h3>
      </el-col>
    </el-row>
    <!-- 篩選  -->
    <el-row class="store-row">
      <el-col :span="22" :offset="1">
        <el-row :gutter="8" class="store-row">
          <el-col :span="4">
            <el-input v-model="kw" placeholder="商家關鍵字" />
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="onSearch" icon="el-icon-search">
              搜尋
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="toAddStorePage"
            >
              新增特約
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="store-row">
      <el-col :span="1" :offset="1">
        <el-select v-model="paging.npp" @change="onSelect">
          <el-option
            v-for="npp in [10, 25, 50, 100]"
            :key="npp"
            :label="npp"
            :value="npp"
          />
        </el-select>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row type="flex" justify="center" class="store-row">
      <el-col :span="22">
        <el-table
          :data="list"
          :header-cell-style="tableHeaderColor"
          empty-text="無資料"
          max-height="800"
          v-loading="loading"
        >
          <el-table-column fixed prop="name" label="名稱" />
          <el-table-column prop="phone" label="電話" />
          <el-table-column prop="driverDiscount" label="司機折扣" />
          <el-table-column prop="companyDiscount" label="企業折扣" />
          <el-table-column label="是否可以叫車">
            <template slot-scope="scope">
              <i
                class="el-icon-check"
                v-if="scope.row.isHailingTaxi"
                style="color: green"
              />
              <i class="el-icon-close" v-else style="color: red" />
            </template>
          </el-table-column>
          <el-table-column prop="note" label="備註" />
          <el-table-column label="編輯">
            <template slot-scope="scope">
              <router-link
                class="red_textcolor"
                :to="{ name: 'EditStore', params: { id: scope.row.id } }"
              >
                編輯資料
              </router-link>
              <el-button size="mini" @click="toRecordPage(scope.row.id)">
                紀錄查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 頁籤  -->
    <el-row type="flex" justify="center" class="store-row">
      <el-pagination
        :span="24"
        background
        layout="prev, pager, next"
        @current-change="onPageChange"
        :current-page="paging.currentPage"
        :page-count="paging.totalPages"
      />
    </el-row>
  </div>
</template>

<script>
import { reqStoreList } from '@/api/specialContract'

export default {
  name: 'StoreList',
  data() {
    return {
      loading: false,
      list: [],
      kw: '',
      paging: {
        currentPage: 1,
        npp: 25,
        totalPages: 1,
        totalEntries: null,
      },
    }
  },
  methods: {
    async fetch(currentPage = 1) {
      try {
        this.loading = true
        const { result } = await reqStoreList({
          npp: this.paging.npp,
          page: currentPage,
          kw: this.kw,
        })
        this.paging.currentPage = currentPage
        this.paging.totalEntries = result.total
        this.paging.totalPages = Math.ceil(result.total / this.paging.npp)
        if (result.total) {
          this.list = result.list
        } else {
          this.list = []
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onPageChange(currentPage) {
      this.paging.currentPage = currentPage
      this.fetch(currentPage)
    },
    onSelect() {
      this.fetch()
    },
    onSearch() {
      this.fetch()
    },
    toAddStorePage() {
      this.$router.push({ name: 'AddStore' })
    },
    toRecordPage(id) {
      this.$router.push({
        name: 'activityRecord',
        query: { id, type: '商家' },
      })
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500; '
      }
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>

<style scoped>
.store-row {
  margin-bottom: 1.2rem;
}
.el-col {
  margin-bottom: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/specialContract/StoreList.vue